<app-login *ngIf="currentUrl === '/login'"></app-login>
<app-nav *ngIf="currentUrl !== '/login'"></app-nav>